let button = document.querySelector('#announcement-close');
let bar = document.querySelector('#announcement');

if(button !== null) {
  button.addEventListener('click', () => {
    bar.remove();
  })
}